import { useMemo } from 'react';
import { useSelector } from 'react-redux';

/** Every location the user can access (`appData.locations`), as unique names sorted A to Z. */
export const useAppLocationNames = (): string[] => {
  const locations = useSelector((state: any) => state.appData?.locations);
  return useMemo(() => {
    const names = (Array.isArray(locations) ? locations : [])
      .map((l: any) => String(l?.name ?? l?.displayText ?? '').trim())
      .filter(Boolean);
    return Array.from(new Set<string>(names)).sort((a, b) => a.localeCompare(b));
  }, [locations]);
};

/** The same list shaped for `DropdownSelect`. */
export const useAppLocationOptions = (): { value: string; label: string }[] => {
  const names = useAppLocationNames();
  return useMemo(() => names.map((name) => ({ value: name, label: name })), [names]);
};
